module.exports = __webpack_public_path__ + "static/media/remark-icon.9e90dc5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/remark-icon.svg
// module id = 308
// module chunks = 0